module.exports = __webpack_public_path__ + "img/trend.1008221d.png";